var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-callback-icon-container"},[_c('img',{staticClass:"b24-web-form-popup-btn-12",attrs:{"src":require("@/assets/img/icons/call.png"),"alt":"Заказать обратный звонок"}})])}
var staticRenderFns = []

export { render, staticRenderFns }